import $ from '/js/header/jquery.js';

$(() => {

    $(`a[data-action="f_open"]`).on('click', (e) => {
        const num = $(e.currentTarget).data('num');
        f_open(num);
        return false;
    });

    $(`a[data-action="f_close"]`).on('click', (e) => {
        const num = $(e.currentTarget).data('num');
        f_close(num);
        return false;
    });
})

function f_open(obj) {
    document.getElementById(`idView${obj}`).style.display = 'none';
    document.getElementById(`idHide${obj}`).style.display = 'block';
    document.getElementById(`idContent${obj}`).style.display = 'block';
}

function f_close(obj) {
    document.getElementById(`idView${obj}`).style.display = 'block';
    document.getElementById(`idHide${obj}`).style.display = 'none';
    document.getElementById(`idContent${obj}`).style.display = 'none';
}